module.exports = __webpack_public_path__ + "img/photo.69befc36.png";